import set from 'lodash.set'

export function setObjectByKey(obj, key, value) {
  const temp = { ...obj }
  return set(temp, key, value)
}

export function handleChange(input, setContent) {
  if (!input) return

  const value =
    input.target.type === 'checkbox' ? input.target.checked : input.target.value

  setContent((prevContent) => ({
    ...prevContent,
    ...setObjectByKey(prevContent, input.target.name, value),
  }))
}

export function handleQuillEditorChange(value, key, setContent) {
  if (!value) return

  setContent((prevContent) => ({
    ...prevContent,
    ...setObjectByKey(prevContent, key, value),
  }))
}

export function handleChangeTrigger(input, setContent) {
  if (!input) return

  const { name } = input.target

  setContent((prevContent) => {
    const setCopy = Array.isArray(prevContent.contentPopup.trigger)
      ? prevContent.contentPopup.trigger
      : []
    let newSet

    if (setCopy.includes(name)) {
      newSet = setCopy.filter((el) => el !== name)
    } else {
      newSet = [...setCopy, name]
    }

    return {
      ...prevContent,
      contentPopup: {
        ...prevContent.contentPopup,
        trigger: newSet,
      },
    }
  })
}
